// extracted by mini-css-extract-plugin
module.exports = {"header":"Main-module--header--2PUxH","maxWidth":"Main-module--maxWidth--3k0xY"};